export class PointSummaryDM {
  constructor({
    total_points = 0,
    expired_at = "",
    current_tier = "",
    total_points_label = "",
    point_categories = [],
    today = 0,
    today_points = 0,
    remaining_points = 0,
    redeemed_points = 0,
    featured_reward = {},
    points_to_next_tier = 0,
    next_tier = "",
  }) {
    this.total_points = total_points;
    this.expired_at = expired_at;
    this.current_tier = current_tier;
    this.total_points_label = total_points_label;
    this.point_categories = point_categories;
    this.today = today;
    this.today_points = today_points;
    this.remaining_points = remaining_points;
    this.redeemed_points = redeemed_points;
    this.featured_reward = featured_reward;
    this.points_to_next_tier = points_to_next_tier;
    this.next_tier = next_tier;
  }

  toJson() {
    return {
      total_points: this.total_points,
      expired_at: this.expired_at,
      current_tier: this.current_tier,
      total_points_label: this.total_points_label,
      point_categories: this.point_categories,
      today: this.today,
      today_points: this.today_points,
      remaining_points: this.remaining_points,
      redeemed_points: this.redeemed_points,
      featured_reward: this.featured_reward,
      points_to_next_tier: this.points_to_next_tier,
      next_tier: this.next_tier,
    };
  }

  static fromJson(json) {
    return new PointSummaryDM({
      total_points: json["total_points"],
      expired_at: json["expired_at"],
      current_tier: json["current_tier"],
      total_points_label: json["total_points_label"],
      point_categories: json["point_categories"],
      today: json["today"],
      today_points: json["today_points"],
      remaining_points: json["remaining_points"],
      redeemed_points: json["redeemed_points"],
      featured_reward: json["featured_reward"],
      points_to_next_tier: json["points_to_next_tier"],
      next_tier: json["next_tier"],
    });
  }
}
